export default class PrepaymentProjectChangeItem {
  constructor() {
    this.ProjectId = '';
    this.LineItemId = '';
    this.CiCcId = '';
  }
}
